import { render, staticRenderFns } from "./AssignmentsTable.vue?vue&type=template&id=56ccb7c6&scoped=true"
import script from "./AssignmentsTable.vue?vue&type=script&lang=js"
export * from "./AssignmentsTable.vue?vue&type=script&lang=js"
import style0 from "./AssignmentsTable.vue?vue&type=style&index=0&id=56ccb7c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ccb7c6",
  null
  
)

export default component.exports